export default __webpack_public_path__ + "img/BB_RTK_NOMA_BF.06cd4382cf371f26c9125b73d92a09d8.jpg";